import { Box, Button, FormControl, Grid, Typography } from '@mui/material'
import { TextField } from 'components/textField'
import { inject, observer } from 'mobx-react'
import { User } from 'models'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { AuthStore } from 'stores'

export interface IFeedbackFormProps {
  authStore?:              AuthStore,
  user?:                   User,
  required?:               boolean,
  hasConfirmationButtons?: boolean,
  onSend?:   (message: string) => Promise<boolean>,
  onCancel?: () => void,
}

export const FeedbackForm = inject('authStore', 'routingStore')(observer((props: IFeedbackFormProps) => {
  const { t } = useTranslation();
  const { onSend, onCancel } = props;
  const [text, setText] = React.useState<string>('');
  const [sent, setSent] = React.useState<boolean>(false);

  const send = async () => {
    const trySendFeedback = await onSend(text);
    setSent(trySendFeedback);
  }

  return (
    <>
      <Grid item xs={12} md={6}>
        {!sent && (<Typography variant='h3'>{t('send_feedback')}</Typography>)}
        <FormControl
          sx={{ display: 'flex', flexDirection: 'column' }}
          margin='normal'
        >
          {!sent && (
            <TextField
              hiddenLabel
              multiline
              rows     = {10}
              maxRows  = {30}
              variant  = 'outlined'
              value    = ''
              onChange = {(e) => setText(e.target.value)}
            />)}
          {sent && (<Typography variant='h3'>{t('sent')}!</Typography>)}

        </FormControl>
      </Grid>

      <Grid item xs={12} md={12}>
        {!sent && (
          <FormControl
            sx     = {{ display: 'flex', flexDirection: 'row' }}
            margin = 'normal'
          >
            <Box>
              <Button
                variant = 'contained'
                onClick = {send}
              >
                {t('send')}
              </Button>
            </Box>
            <Button variant='text' onClick={onCancel}>
              {t('cancel')}
            </Button>
          </FormControl>
        )}
        {sent && (
          <FormControl
            sx     = {{ display: 'flex', flexDirection: 'row' }}
            margin = 'normal'
          >
            <Box></Box>
            <Box>
              <Button
                variant = 'contained'
                onClick = {onCancel}
              >
                {t('close')}
              </Button>
            </Box>
          </FormControl>
        )}
      </Grid>
    </>
  );
}));
